// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD1pSzUQFxdr-J_YtiW9VW8lBxUFWN6Wfk',
  authDomain: 'easyros-62675.firebaseapp.com',
  projectId: 'easyros-62675',
  storageBucket: 'easyros-62675.appspot.com',
  messagingSenderId: '722775507944',
  appId: '1:722775507944:web:3a359dba760f7f2b0d1a5d',
  measurementId: 'G-4MGJN431R9'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

export { auth, app };
